import React from 'react';

function MobileLogoComponent(props) {
  const { className, height } = props;
  return (
    <img alt="logo" className={className} src="/logo192.png" height={height} />
  );
}
export default MobileLogoComponent;
